<template>
  <div class="inline-block">
    <div class="relative inline-block text-left">
      <div>
        <div class="flex items-center gap-2">
          <ButtonMenu :sections="1">
            <template v-slot:overrideTitle>
              <vue-feather type="more-horizontal" class="h-5" />
            </template>
            <template v-slot:topmenu>
              <a
                :href="`${$store.state.general.currentUserAccountDetails.scheduleFollowupLink}&contact_id=${$route.params.id}`"
                target="_blank"
                class="cursor-pointer group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
              >
                <svg
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                  />
                </svg>
                Schedule Follow-up
              </a>
              <a
                class="cursor-pointer group flex xl:hidden items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
                @click="handleAction('esignature')"
                data-track="clicked-esignature-candidate-button"
              >
                <vue-feather
                  type="feather"
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                />
                Send E-signature
              </a>
              <a
                class="cursor-pointer group flex xl:hidden items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
                @click="handleAction('assign-tasks')"
                data-track="clicked-esignature-candidate-button"
              >
                <vue-feather
                  type="user-check"
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                />
                Assign Tasks
              </a>
              <a
                class="cursor-pointer group flex xl:hidden items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
                @click="handleAction('chat')"
              >
                <svg
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
                  <line x1="12" y1="12" x2="12" y2="12.01" />
                  <line x1="8" y1="12" x2="8" y2="12.01" />
                  <line x1="16" y1="12" x2="16" y2="12.01" />
                </svg>
                Chat
              </a>
              <a
                class="cursor-pointer group flex xl:hidden items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
                @click="handleAction('email')"
                data-track="clicked-email-candidate-button"
              >
                <svg
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                  />
                </svg>
                Email
              </a>
              <router-link
                :to="`${$route.fullPath}/edit`"
                class="cursor-pointer group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
              >
                <svg
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4" />
                  <line x1="13.5" y1="6.5" x2="17.5" y2="10.5" />
                </svg>
                Edit
              </router-link>
              <a
                class="cursor-pointer group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                role="menuitem"
                @click="handleAction('delete')"
              >
                <svg
                  class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <line x1="4" y1="7" x2="20" y2="7" />
                  <line x1="10" y1="11" x2="10" y2="17" />
                  <line x1="14" y1="11" x2="14" y2="17" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
                Delete
              </a>
            </template>
          </ButtonMenu>
          <a
            class="mr-1 cursor-pointer group hidden xl:flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
            @click="handleAction('esignature')"
            data-track="clicked-email-candidate-button"
          >
            <vue-feather
              type="feather"
              class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
            />
            Send E-signature
          </a>
          <a
            class="mr-1 cursor-pointer group hidden xl:flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
            @click="handleAction('assign-tasks')"
            data-track="clicked-email-candidate-button"
          >
            <vue-feather
              type="user-check"
              class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
            />
            Assign Tasks
          </a>
          <a
            class="mr-1 cursor-pointer group hidden xl:flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
            @click="handleAction('chat')"
          >
            <svg
              class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
              <line x1="12" y1="12" x2="12" y2="12.01" />
              <line x1="8" y1="12" x2="8" y2="12.01" />
              <line x1="16" y1="12" x2="16" y2="12.01" />
            </svg>
            Chat
          </a>

          <a
            class="mr-1 cursor-pointer group hidden xl:flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
            @click="handleAction('email')"
            data-track="clicked-email-candidate-button"
          >
            <svg
              class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              />
            </svg>
            Email
          </a>

          <contact-stage-update-button
            :contact="record"
            @disqualify-candidate="showContactDisqualify = true"
            @onboard-candidate="handleAction('onboard')"
          />
        </div>
      </div>

      <Chat v-if="showContactChat" :record="record" @handleContactChatCancel="handleContactChatCancel" />
      <Email v-if="showContactEmail" :record="record" @handleContactEmailCancel="handleContactEmailCancel" />
      <ContactUnsubscribe
        v-if="showContactUnsubscribe"
        @handleContactUnsubscribe="handleContactUnsubscribe"
        @handleContactUnsubscribeCancel="handleContactUnsubscribeCancel"
      />
      <ContactDelete
        v-if="showContactDelete"
        @handleContactDelete="handleContactDelete"
        @handleContactDeleteCancel="handleContactDeleteCancel"
      />
      <ContactOnboard
        v-if="showContactOnboard"
        :record="record"
        @handleContactOnboard="handleContactOnboard"
        @handleContactOnboardCancel="handleContactOnboardCancel"
      />
      <ContactDecline
        v-if="showContactDecline"
        @handleContactDeclined="handleContactDeclined"
        @handleContactDeclinedCancel="handleContactDeclinedCancel"
      />
      <ContactDisqualify
        v-if="showContactDisqualify"
        @handleContactDisqualify="handleContactDisqualify"
        @handleContactDisqualifyCancel="handleContactDisqualifyCancel"
      />
      <ContactHired
        v-if="showContactHired"
        @handleContactHired="handleContactHired"
        @handleContactHiredCancel="handleContactHiredCancel"
      />
      <ContactEsignature
        v-if="showContactEsignature"
        :record="record"
        @handleSubmit="showContactEsignature = false"
        @handleCancel="showContactEsignature = false"
      />
      <ContactAssignTasks
        v-if="showContactAssignTasks"
        :record="record"
        @handleSubmit="showContactAssignTasks = false"
        @handleCancel="showContactAssignTasks = false"
      />
    </div>
  </div>
</template>

<script>
import ContactStageUpdateButton from './ContactStageUpdateButton.vue';
import ButtonMenu from '../shared/ButtonMenu.vue';
import Chat from '../shared/Chat.vue';
import Email from '../shared/Email.vue';
import ContactUnsubscribe from './ContactUnsubscribe.vue';
import ContactDelete from './ContactDelete.vue';
import ContactOnboard from './ContactOnboard.vue';
import ContactDecline from './ContactDecline.vue';
import ContactDisqualify from './ContactDisqualify.vue';
import ContactHired from './ContactHired.vue';
import ContactEsignature from './ContactEsignature.vue';
import ContactAssignTasks from './ContactAssignTasks.vue';

export default {
  props: ['record'],
  components: {
    ButtonMenu,
    Chat,
    Email,
    ContactUnsubscribe,
    ContactDelete,
    ContactOnboard,
    ContactDecline,
    ContactDisqualify,
    ContactHired,
    ContactStageUpdateButton,
    ContactEsignature,
    ContactAssignTasks,
  },
  data() {
    return {
      showOptions: false,
      showContactUnsubscribe: false,
      showContactDelete: false,
      showContactChat: false,
      showContactEmail: false,
      showContactOnboard: false,
      showContactDecline: false,
      showContactDisqualify: false,
      showContactHired: false,
      showContactEsignature: false,
      showContactAssignTasks: false,
    };
  },
  mounted() {},
  methods: {
    handleAction(e) {
      this.showOptions = false;
      if (e == 'unsubscribe') {
        this.showContactUnsubscribe = true;
      }
      if (e == 'delete') {
        this.showContactDelete = true;
      }
      if (e == 'chat') {
        this.showContactChat = true;
      }
      if (e == 'email') {
        this.showContactEmail = true;
      }
      if (e == 'onboard') {
        this.showContactOnboard = true;
      }
      if (e == 'decline') {
        this.showContactDecline = true;
      }
      if (e == 'disqualify') {
        this.showContactDisqualify = true;
      }
      if (e == 'hired') {
        this.showContactHired = true;
      }
      if (e == 'esignature') {
        this.showContactEsignature = true;
      }
      if (e == 'assign-tasks') {
        this.showContactAssignTasks = true;
      }
    },
    handleContactUnsubscribe() {
      this.$emit('reload');
    },
    handleContactUnsubscribeCancel() {
      this.showContactUnsubscribe = false;
    },
    handleContactDelete() {},
    handleContactDeleteCancel() {
      this.showContactDelete = false;
    },
    handleContactChatCancel() {
      this.showContactChat = false;
    },
    handleContactEmailCancel() {
      this.showContactEmail = false;
    },
    handleContactOnboard() {
      this.showContactOnboard = false;
      this.$emit('reload');
    },
    handleContactOnboardCancel() {
      this.showContactOnboard = false;
    },
    handleContactDeclined() {
      this.$emit('reload');
    },
    handleContactDeclinedCancel() {
      this.showContactDecline = false;
    },
    handleContactDisqualify() {
      this.$emit('reload');
    },
    handleContactDisqualifyCancel() {
      this.showContactDisqualify = false;
    },
    handleContactHired() {
      this.$emit('reload');
    },
    handleContactHiredCancel() {
      this.showContactHired = false;
    },
  },
};
</script>
